import { useFilterLeaveTypeContext } from "./filter-leave-type.context";

export function FilterLeaveType() {
  const { dateFilterElement, reportFilterElements, clearFiltersElement } =
    useFilterLeaveTypeContext();

  return (
    <div>
      <h2>Filters</h2>
      <p className="mb-4">
        Select the following filters you want to apply to the current table.
      </p>

      {dateFilterElement}
      {reportFilterElements}
      {clearFiltersElement}
    </div>
  );
}